import { useState } from 'react';
import ProfileContainer from "../components/ProfileContainer";

const AgencyProfileAboutUs = ({ items }) => {
    const [isOpen, setIsOpen] = useState(true);

    // console.log(items, 'ITEMS')
    return (
        <div id="about-us" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg pb-6">About Us</h4>

                    <div className="flex items-center gap-6 pb-6">
                        <a
                            className="textxs btn-link btn-link-primary"
                            href={items.website}
                            target="_blank"
                        >
                            {items.website}
                        </a>

                        <p>{laravel.client_sizes[items.size]}</p>

                        {items.is_black_owned && (
                            <p>Black Owned</p>
                        )}
                        {items.is_woman_owned && (
                            <p>Woman Owned</p>
                        )}
                    </div>

                    <div>
                        <p className="text-base pb-2">Our Bio</p>
                        <div dangerouslySetInnerHTML={{ __html: items.about }} />
                    </div>

                </div>
            </ProfileContainer>
        </div>
    )
}

export default AgencyProfileAboutUs;
